import DecedentMarital from '@/common/containers/Forms/DecedentMarital/DecedentMarital';

export default DecedentMarital;
